// extracted by mini-css-extract-plugin
export default {"root":"AddToCartButton_root__6u41c"};